import { render, staticRenderFns } from "./_AdvertsWrapper.vue?vue&type=template&id=4e5a35af&scoped=true&"
import script from "./_AdvertsWrapper.vue?vue&type=script&lang=js&"
export * from "./_AdvertsWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5a35af",
  null
  
)

export default component.exports